// src/js/reducers/index.js
import * as types from "../constants/action-types";

  
export default function worksiteStatReducer(state = {startLoss: [], endLoss:[], worksiteStats2: []}, action) {

    switch (action.type) {
        
        case types.LOGOUT:
            return []
        case types.LOAD_WORKSITE_START_LOSS_SUCCESS:
           
            var result = Object.assign({}, state);
            result.startLoss = action.stats;
            return result;
        
        case types.LOAD_WORKSITE_END_LOSS_SUCCESS:
           
            var result = Object.assign({}, state);
            result.endLoss = action.stats;
            return result;
        
        case types.LOAD_WORKSITE_STATS_SUCCESS2:
           
            var result = Object.assign({}, state);
            result.worksiteStats2 = action.stats;
            return result;

        default:
            return state;
    };
};
